import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { isFeatureEnabled } from 'owa-feature-flags';
import { LocationCardWrapperV2 } from 'owa-location-card-v2';
import { LocationCardWrapper } from 'owa-location-persona';
import PersonaPostalAddress from 'owa-service/lib/contract/PersonaPostalAddress';
import * as React from 'react';

/**
 * Returns the location element wrapped in LocationCardWrapper card or LocationCardWrapperV2
 */
export function wrapWithLocationCard(
    name: string,
    postalAddress: PersonaPostalAddress,
    locationId: string,
    locationElement: JSX.Element,
    colorScheme: ColorScheme,
    onLocationCardUnmounted: (...args: any[]) => void
): JSX.Element {
    return isFeatureEnabled('cal-locationCard') ? (
        <LocationCardWrapperV2
            name={name}
            postalAddress={postalAddress}
            key={locationId}
            locationId={locationId}
            colorScheme={colorScheme}
            onLocationCardUnmounted={onLocationCardUnmounted}>
            {locationElement}
        </LocationCardWrapperV2>
    ) : (
        <LocationCardWrapper
            name={name}
            postalAddress={postalAddress}
            key={locationId}
            colorScheme={colorScheme}>
            {locationElement}
        </LocationCardWrapper>
    );
}
